import { takeLatest, takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';

function* add(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/facturacion/', requestOptions);
        yield put({ type: "FACTURACION_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "FACTURACION_RESPONSE", value: error })
    }
}

function* hashExportFacturacion(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/get_reservation/', requestOptions);

        yield put({ type: "HASH_EXPORT_FACTURACION_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "HASH_EXPORT_FACTURACION_RESPONSE", value: error })
    }
}


function* checkExportFacturacion(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        const response = yield call(
            apiCall,
            'GET',
            config.credentials.url + '/report/' + actions.hash + '/',
            requestOptions
        );

        yield put({ type: 'REPORT_EXPORT_FACTURACION_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'REPORT_EXPORT_FACTURACION_RESPONSE', value: error });
    }
}

function* getInvoices(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/send_invoice/?offset=0&limit=' + actions.limit : config.credentials.url + '/send_invoice/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)
        response.view = 'list'

        yield put({ type: "INVOICES_LIST_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "INVOICES_LIST_RESPONSE", value: error })
    }
}

function* invoice(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/send_invoice/' : config.credentials.url + '/send_invoice/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)
        response.view = 'show'

        yield put({ type: "INVOICE_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "INVOICE_RESPONSE", value: error })
    }
}


export function* addFacturacion() {
    yield takeEvery("ADD_FACTURACION", add)
}

export function* getHashExportFacturacionList() {
    yield takeEvery('GET_HASH_EXPORT_FACTURACION', hashExportFacturacion);
}

export function* checkExportFacturacionList() {
    yield takeEvery('CHECK_EXPORT_FACTURACION', checkExportFacturacion);
}

export function* getInvoicesList() {
    yield takeEvery("GET_INVOICES", getInvoices)
}

export function* getInvoice() {
    yield takeEvery("GET_INVOICE", invoice)
}